
export const UPDATE_CONTAINER_ID = 'gtm/UPDATE_CONTAINER_ID';
export const INITIALIZE_GTM = 'gtm/INITIALIZE_GTM';
export const INITIALIZE_GTM_TAG_STEPS = 'gtm/INITIALIZE_GTM_TAG_STEPS';

export interface UpdateContainerAction {
  type: typeof UPDATE_CONTAINER_ID;
  payload: string;
}

export interface InitializeGtmAction {
  type: typeof INITIALIZE_GTM;
  payload: boolean;
}

export interface InitializeGtmTagSteps {
  type: typeof INITIALIZE_GTM_TAG_STEPS;
  payload: Array<string>;
}
// --- Create Union Type

export type GtmActionsTypes = UpdateContainerAction | InitializeGtmAction | InitializeGtmTagSteps;
